import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { IToastProps } from "../../../interfaces/common/ui/IAppToast";

const AppToast: React.FC<IToastProps> = ({
  open,
  onClose,
  message,
  severity,
  autoHideDuration,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <MuiAlert
        onClose={(event) => onClose(event)}
        severity={severity as any}
        elevation={6}
        variant='filled'
        sx={{ whiteSpace: "pre-line" }}
      >
        {(() => {
          // Ensure message is always displayed as a readable string
          let displayMessage: string;
          
          if (typeof message === "string") {
            displayMessage = message;
          } else if (message && typeof message === "object") {
            // Handle object messages gracefully
            if ((message as any).message) {
              displayMessage = String((message as any).message);
            } else if ((message as any).detail) {
              displayMessage = String((message as any).detail);
            } else if ((message as any).error) {
              displayMessage = String((message as any).error);
            } else {
              try {
                displayMessage = JSON.stringify(message);
                if (displayMessage === "{}") {
                  displayMessage = "An error occurred";
                }
              } catch {
                displayMessage = "An error occurred";
              }
            }
          } else {
            displayMessage = String(message || "An error occurred");
          }
          
          // Handle HTML content
          if (displayMessage.includes("<br>")) {
            return <span dangerouslySetInnerHTML={{ __html: displayMessage }} />;
          }
          
          return displayMessage;
        })()}
      </MuiAlert>
    </Snackbar>
  );
};

export default AppToast;
